<template>
    <v-row>
        <v-col>            
            <!--<v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                                                    
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between">                                       
                                    
                                    <h5 class="ma-1 mt-6" >Capacity Utilization Report</h5> 
                                </div>                                 
                                <div class="d-flex flex"></div>
                                <div style="width: 350px;"> 
                                    <v-menu                                    
                                        ref="calcDatepicker"
                                        v-model="calculationDatepickerFrom"
                                        :close-on-content-click="false"
                                        
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{on, attrs}">
                                            <v-text-field
                                            class="ma-4 mb-0 d-flex flex"
                                                label='From'
                                                dense
                                                outlined
                                                v-model="calculationDateFrom"                                              
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details    
                                                :clearable="true"                                                       
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="calculationDateFrom" :max="datepickerMaxLimit" scrollable>                    
                                        </v-date-picker>
                                    </v-menu>
                                </div>     
                                <div style="width: 350px;"> 

                                    <v-menu                                    
                                    ref="calcDatepicker"
                                    v-model="calculationDatepickerTo"
                                    :close-on-content-click="false"
                                    
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{on, attrs}">
                                        <v-text-field
                                        class="ma-4 mb-0 d-flex flex"                                            
                                            label='To'
                                            dense
                                            outlined
                                            v-model="calculationDateTo"                                              
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            hide-details    
                                            :clearable="true"                                                       
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="calculationDateTo" :max="datepickerMaxLimit" scrollable>                    
                                    </v-date-picker>
                                </v-menu>
                                </div>                         
                                
                                <v-btn class="maz-4 mt-4" dark color="primary" @click="getData" :loading="progressStatsLoading">
                                        <v-icon>mdi-reload</v-icon>
                                        Reload
                                </v-btn>
                            </div>
                        </v-card-title>                                        
                        <v-progress-linear
                            :active="progressStatsLoading"
                            :indeterminate="progressStatsLoading"
                            absolute
                            bottom
                            color="deep-purple accent-4"
                        />
                    </base-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pl-2">
                            <v-card-title>Total Utilization</v-card-title>
                        </div>                        
                    </base-card>
                </v-col>
            </v-row>  -->
            <v-row > 
                <!--<v-col cols="12">
                    <div class="body-2" style="color: #d10d13">
                        {{o.title}}
                    </div> 
                </v-col>-->
                <v-col cols="4">
                    <card-dashboard secondaryvalue="Brands" title="" :primaryvalue="dashboard.brands" ></card-dashboard>
                </v-col>
                 <v-col cols="4">
                    <card-dashboard secondaryvalue="Brand Representatives" title="" :primaryvalue="dashboard.brandRepresentatives" ></card-dashboard>
                </v-col>
                 <v-col cols="4">
                    <card-dashboard secondaryvalue="Organizations" title="" :primaryvalue="dashboard.organizations" ></card-dashboard>
                </v-col>
                <!--<v-col cols="3">
                    <card-dashboard title="Utilization" :primaryvalue="utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                </v-col>-->                
            </v-row>
            <v-row>
                <v-col md="6" sm="12">
                    <v-row>
                        <v-col cols="12">
                            <base-card>
                                <v-card-title>
                                    <div class="d-flex justify-space-between" style="width: 100%;">
                                        <div class="d-flex justify-space-between">                                                                           
                                            <h5 class="ma-1 mt-4" >Campaigns</h5> 
                                        </div>
                                        <div class="d-flex flex"></div>
                                        <v-btn class="maz-4 mt-2" dark color="primary" :loading="progressStatsLoading" to="/mng/campaigns/ongoing">                                    
                                            See all campaigns
                                            <v-icon>mdi-chevron-right</v-icon>
                                        </v-btn> 
                                    </div>                            
                                </v-card-title>                                       
                            </base-card>
                        </v-col>
                    </v-row>  
                    <v-row>
                        <v-col cols="12">                                        
                            <!--<v-select class="ml-4" style="max-width: 200px;" label="Filter Campaigns" v-model="campaignFilter" :items="campaignFilterOptions"></v-select>-->
                            <v-simple-table  style="display: block; width: 100%">
                                <thead>
                                    <tr>
                                        <th>Per Status</th>
                                        <th>Budget</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody v-if="progressStatsLoading" class="tinytablelistt">
                                            <tr v-for="idx in 5" :key="`campaign-skeleton-${idx}`">
                                                <td class="nobottomborder">
                                                    <v-skeleton-loader type="text" width="180" />
                                                </td>
                                                <td class="nobottomborder">
                                                    <v-skeleton-loader type="text" width="90" />
                                                </td>
                                                <th>&nbsp;</th>
                                                <td class="nobottomborder" style="text-align: end;">
                                                    <v-skeleton-loader type="avatar" width="24" />
                                                </td>
                                            </tr>
                                </tbody>
                                <tbody v-else class="tinytablelistt">      
                                            <tr>
                                                <td class="nobottomborder">Running: {{ dashboard.campaigns.released.count }}</td>
                                                <td class="nobottomborder">{{ formatBudget(dashboard.campaigns.released.budget) }}</td>    
                                                <th>&nbsp;</th>                                
                                                <td class="nobottomborder" style="text-align: end;">
                                                    <v-tooltip top style="margin-left: 50px;">
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn                                        
                                                                dark
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                icon
                                                                @click="openCampaignStatusDetails('released')"                                                                
                                                            >
                                                                <v-icon>mdi-file-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>View Details</span>
                                                    </v-tooltip>
                                                </td> 
                                            </tr>   
                                            <tr>
                                                <td class="nobottomborder">Stopped: {{ dashboard.campaigns.stopped.count }}</td>
                                                <td class="nobottomborder">{{ formatBudget(dashboard.campaigns.stopped.budget) }}</td>   
                                                <th>&nbsp;</th>    
                                                <td class="nobottomborder" style="text-align: end;">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn                                        
                                                                dark
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                icon
                                                                @click="openCampaignStatusDetails('stopped')"                                                                
                                                            >
                                                                <v-icon>mdi-file-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>View Details</span>
                                                    </v-tooltip>
                                                </td>                              
                                            </tr> 
                                            <tr>
                                                <td class="nobottomborder">Completed: {{ dashboard.campaigns.completed.count }}</td>
                                                <td class="nobottomborder">{{ formatBudget(dashboard.campaigns.completed.budget) }}</td>   
                                                <th>&nbsp;</th>
                                                <td class="nobottomborder" style="text-align: end;">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn                                        
                                                                dark
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                icon
                                                                @click="openCampaignStatusDetails('completed')"                                                                
                                                            >
                                                                <v-icon>mdi-file-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>View Details</span>
                                                    </v-tooltip>
                                                </td>                                  
                                            </tr> 
                                            <tr>
                                                <td class="nobottomborder">Proposed: {{ dashboard.campaigns.proposal.count }}</td>
                                                <td class="nobottomborder">{{ formatBudget(dashboard.campaigns.proposal.budget) }}</td>     
                                                <th>&nbsp;</th>
                                                <td class="nobottomborder" style="text-align: end;">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn                                        
                                                                dark
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                icon
                                                                @click="openCampaignStatusDetails('proposal')"                                                                
                                                            >
                                                                <v-icon>mdi-file-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>View Details</span>
                                                    </v-tooltip>
                                                </td>                                
                                            </tr>
                                            <tr>
                                                <td class="nobottomborder">Under-performing: {{ dashboard.campaigns.underperforming.count }}</td>
                                                <td class="nobottomborder">{{ formatBudget(dashboard.campaigns.underperforming.budget) }}</td> 
                                                <th>&nbsp;</th>
                                                <td class="nobottomborder" style="text-align: end;">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn                                        
                                                                dark
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                icon
                                                                @click="openCampaignStatusDetails('underperforming')"                                                                
                                                            >
                                                                <v-icon>mdi-file-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>View Details</span>
                                                    </v-tooltip>
                                                </td>                                    
                                            </tr>                                                                 
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col md="6" sm="12">
                    <v-row>
                        <v-col cols="12">
                            <base-card>
                                <v-card-title>
                                    <div class="d-flex justify-space-between" style="width: 100%;">
                                        <div class="d-flex justify-space-between">                                                                           
                                            <h5 class="ma-1 mt-4" >Adpoints</h5> 
                                        </div>
                                        <div class="d-flex flex"></div>
                                        <v-btn class="maz-4 mt-2" dark color="primary" :loading="progressStatsLoading" to="/mng/adpoints/dashboard">                                    
                                            See all adpoints
                                            <v-icon>mdi-chevron-right</v-icon>
                                        </v-btn> 
                                    </div>                            
                                </v-card-title>                                       
                            </base-card>
                        </v-col>
                    </v-row>  
                    <v-row >                         
                        <v-col cols="6">
                            <card-dashboard secondaryvalue="Total Adpoints" title="" :primaryvalue="dashboard.totalAdpoints" ></card-dashboard>
                        </v-col>
                        <v-col cols="6">
                            <card-dashboard secondaryvalue="Total Networks" title="" :primaryvalue="dashboard.totalNetworks" ></card-dashboard>
                        </v-col>                                 
                    </v-row>
                    <v-row >                                                 
                        <v-col cols="6">
                            <card-dashboard secondaryvalue="Placement Types" title="" :primaryvalue="dashboard.placementTypes" ></card-dashboard>
                        </v-col>
                            <v-col cols="6">
                            <card-dashboard secondaryvalue="Clusters" title="" :primaryvalue="dashboard.clusters" ></card-dashboard>
                        </v-col>                                                                 
                    </v-row>
                </v-col>
            </v-row>                        
            
             <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between">                                                                           
                                    <h5 class="ma-1 mt-4" >Capacity</h5> 
                                </div>
                                <div class="d-flex flex"></div>
                                <v-btn class="maz-4 mt-2" dark color="primary" :loading="progressStatsLoading" to="/mng/adpoints/networks">                                    
                                    See all networks
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn> 
                            </div>                            
                        </v-card-title>                                       
                    </base-card>
                </v-col>
            </v-row>   
            <v-row > 
                <!--<v-col cols="12">
                    <div class="body-2" style="color: #d10d13">
                        {{o.title}}
                    </div> 
                </v-col>-->
                <v-col cols="3">
                    
                </v-col>
                 <v-col cols="3">
                          <card-dashboard secondaryvalue="Total Capacity" title="Daily Impressions" :primaryvalue="dashboard.totalCapacity" ></card-dashboard>
                </v-col>
                 <v-col cols="3">
                          <card-dashboard secondaryvalue="Total Booked Capacity" title="Monetized Impressions" :primaryvalue="dashboard.totalBookedCapacity" ></card-dashboard>
                </v-col>
                <v-col cols="3">
                    
                </v-col>
                <!--<v-col cols="3">
                    <card-dashboard title="Utilization" :primaryvalue="utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                </v-col>-->                
            </v-row>
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between">                                                                           
                                    <h5 class="ma-1 mt-4" >Revenue</h5> 
                                </div>
                                <div class="d-flex justify-space-between">                                                                           
                                    <div class="ma-1 mt-4 ml-1" style="font-size: 0.6em" >Last 30 Days</div> 
                                </div>
                                <div class="d-flex flex"></div>                                
                            </div>                            
                        </v-card-title>                                       
                    </base-card>
                </v-col>
            </v-row> 
            <v-row> 
                <!--<v-col cols="12">
                    <div class="body-2" style="color: #d10d13">
                        {{o.title}}
                    </div> 
                </v-col>-->
                <v-col cols="3">
                    
                </v-col>
                 <v-col cols="3">
                          <card-dashboard secondaryvalue="Total" title="" valueformatting="x" :primaryvalue="dashboard.revenueTotal" unit="€" ></card-dashboard>
                </v-col>
                 <v-col cols="3">
                          <card-dashboard secondaryvalue="Generated" title="" valueformatting="x" :primaryvalue="dashboard.revenueGenerated" unit="€" ></card-dashboard>
                </v-col>
                <v-col cols="3">
                    
                </v-col>
                <!--<v-col cols="3">
                    <card-dashboard title="Utilization" :primaryvalue="utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                </v-col>-->                
            </v-row>
            <!--<v-tabs v-model="tabs_selection" color="#FFF" class="mb-3 mt-3">
                <v-tab style="text-transform: none;"  ><v-card-title>Networks Utilization</v-card-title></v-tab>
                <v-tab style="text-transform: none;" ><v-card-title>Clusters Utilization</v-card-title></v-tab>
            </v-tabs>
            <template v-if="tabs_selection==0">
                <v-row  v-for="o in networks" :key="o.id"> 
                    <v-col cols="3">
                        <card-dashboard title="No of AdPoints" :primaryvalue="o.total_adpoints" :secondaryvalue="o.title" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Total Impressions" :primaryvalue="o.total_capacity" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Available Impressions" :primaryvalue="o.available_impressions" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Utilization" :primaryvalue="o.utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                    </v-col>                
                </v-row> 
            </template>      
            <template v-if="tabs_selection==1">
                <v-row v-for="o in clusters" :key="o.id"> 
                    <v-col cols="3">
                        <card-dashboard title="No of AdPoints" :primaryvalue="o.total_adpoints" :secondaryvalue="o.title" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Total Impressions" :primaryvalue="o.total_capacity" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Available Impressions" :primaryvalue="o.available_impressions" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Utilization" :primaryvalue="o.utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                    </v-col>                
                </v-row> 
            </template>    -->              
            

            <v-snackbar
                v-model="mysnackbar"
                :timeout="4000"
                bottom
                tile
                color="red"            
                >                
            </v-snackbar>
        </v-col>
    </v-row>
</template>

<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
import moment from "moment";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList";
import {GGanttChart, GGanttRow} from 'vue-ganttastic';
import { GChart } from 'vue-google-charts/legacy';
import CardDashboard from "@/components/campaigns/CardDashboard";
import ReportRuleComponent from "@/components/campaigns/campaign-report-rule-component";
import {parseDate, formatDate} from '@/core/date-utils.js';
import { formatCurrencyEUR } from '@/core/number-utils.js'
// import Gantt from '@salamander.be/vue-gantt/src/components/gantt.vue';
import {
    gradientLineChart,
    salesByCountries,
    visitorsAnalytic
} from '@/data/sales2';
import {
  analyticOne,
  analyticTwo,
  analyticThree,
  analyticFour,
  analyticFive,
} from "@/data/analytic2";

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoints Management'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList    ,
        GGanttChart,
        GGanttRow,
        GChart,
        CardDashboard,
        "report-rule-component": ReportRuleComponent
       // Gantt  
    },
    data() {
        return {            
            mysnackbar: false,    
            mysnackbar_msg: "",       
            progressStatsLoading: true,   
            tabs_selection: null,
            
            calculationDateFrom: null,
            calculationDatepickerFrom: null,
            calculationDateTo: null,
            calculationDatepickerTo: null,
            datepickerMaxLimit: null,

            total_adpoints: null,
            total_capacity: null,
            available_impressions: null,
            utilization_pct: null,

            networks: [],

            clusters: [],

            dashboard: {
                brands: 0,
                brandRepresentatives: 0,
                organizations: 0,
                totalAdpoints: 0,
                totalNetworks: 0,
                placementTypes: 0,
                clusters: 0,
                totalCapacity: 0,
                totalBookedCapacity: 0,
                revenueTotal: 0,
                revenueGenerated: 0,
                campaigns: {
                    released: { count: 0, budget: 0 },
                    stopped: { count: 0, budget: 0 },
                    completed: { count: 0, budget: 0 },
                    proposal: { count: 0, budget: 0 },
                    underperforming: { count: 0, budget: 0 },
                }
            },                        
        }
    },
    filters: {

    },
    watch: {
      
    },
    computed: {

    },
    methods: {
        openCampaignStatusDetails(status) {
            const routeData = this.$router.resolve({
                name: 'campaigns-ongoing',
                query: { status }
            });

            window.open(routeData.href, '_blank', 'noopener');
        },
        
        async exportDocument(selectedCampaign) {
            
            await new Promise(resolve => setTimeout(resolve, 12000));
            this.progressStatsLoading = false;
            //this.mysnackbar=true;
            this.progressStatsLoading=false;
        },

        formatBudget(value) {
            return formatCurrencyEUR(value || 0, 2);
        },

        async getData() {
            this.progressStatsLoading=true;
            try {
                const rsp = await srvApi.get(PATH.REPORTING_MAIN_DASHBOARD);
                const src = rsp?.data || {};

                this.dashboard.brands = src.brands || 0;
                this.dashboard.brandRepresentatives = src.brandRepresentatives || 0;
                this.dashboard.organizations = src.organizations || 0;
                this.dashboard.totalAdpoints = src.totalAdpoints || 0;
                this.dashboard.totalNetworks = src.totalNetworks || 0;
                this.dashboard.placementTypes = src.placementTypes || 0;
                this.dashboard.clusters = src.clusters || 0;
                this.dashboard.totalCapacity = src.totalCapacity || 0;
                this.dashboard.totalBookedCapacity = src.totalBookedCapacity || 0;
                this.dashboard.revenueTotal = src?.revenue?.total || 0;
                this.dashboard.revenueGenerated = src?.revenue?.generated || 0;
                this.dashboard.campaigns.released = src?.campaigns?.released || { count: 0, budget: 0 };
                this.dashboard.campaigns.stopped = src?.campaigns?.stopped || { count: 0, budget: 0 };
                this.dashboard.campaigns.completed = src?.campaigns?.completed || { count: 0, budget: 0 };
                this.dashboard.campaigns.proposal = src?.campaigns?.proposal || { count: 0, budget: 0 };
                this.dashboard.campaigns.underperforming = src?.campaigns?.underperforming || { count: 0, budget: 0 };

            } catch (error) {
                this.mysnackbar_msg= "Error: " + (error.message || error.msg || "Server Error");
                this.mysnackbar=true;
            }
            finally {
                this.progressStatsLoading=false;
            }
            
        }

        
    },
    async created() {
        let today = new Date();
        let sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        let oneDayAgo = new Date();
        oneDayAgo.setDate(oneDayAgo.getDate() - 1);
        let thirtyDaysAfter = new Date();
        thirtyDaysAfter.setDate(thirtyDaysAfter.getDate() + 30);
        this.calculationDateFrom = sevenDaysAgo.toISOString().substring(0,10);
        this.calculationDateTo = oneDayAgo.toISOString().substring(0,10);
        this.datepickerMaxLimit = thirtyDaysAfter.toISOString().substring(0,10);
    },
    async mounted() {
        //await new Promise(resolve => setTimeout(resolve, 12000));
        // const basicData = await srvApi.get(PATH.NETWORK_ASOPTIONS);
        // this.networkOptions.push(...basicData.data.map(i=>({value: i.extra.code, text: i.text})));

        // if(this.$route.params.code) {
        //     this.code = this.$route.params.code;
        // }      
        // else {
        //     if(this.networkOptions.length>0) {
        //         this.code = this.networkOptions[0].value
        //     }
        // }  
        await this.getData();
        
        //this.mysnackbar=true;
        this.progressStatsLoading=false;

        /*
        let ff = this.filterfields.find(i=>i.selectvalue === "brand");        
        if(ff) {
            const rsp = await api.brand.getAll();            
            ff.listItems = rsp.data.map(i=> {return {selectvalue: i.code, selecttext: i.title}});
        }
        */
    }
}
</script>
<style lang="scss" scoped>

.v-card__title {
    color: #FFF
}

.v-application.primary--text {
    color: #FFF
}

.active {
       color: #222222 !important;
       background-color: #ffff !important;
    }
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -10px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

</style>
